import axios from 'axios';

const API_URL = 'https://app.techtidellc.com/api';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  const formData = new URLSearchParams();
  formData.append('username', email);
  formData.append('password', password);
  const res = await api.post('/auth/login', formData, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
  return res.data;
};

export const getMe = () => api.get('/auth/me');
export const getSuggestions = () => api.get('/suggestions');
export const decideSuggestion = (id, decision, reason) =>
  api.post(`/suggestions/${id}/decide`, { decision, reason });
export const getTasks = () => api.get('/tasks');
export const assignTask = (data) => api.post('/tasks/assign', data);
export const submitTask = (task_id, submission_text) =>
  api.post('/tasks/submit', { task_id, submission_text });
export const submitReport = (data) => api.post('/reports/submit', data);
export const runOrchestrator = () => api.post('/orchestrator/run');
export const getPerformance = () => api.get('/analytics/performance');
export const getSystemLogs = () => api.get('/system/logs');

export default api;
